import script from "./ConfigurationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigurationModal.vue?vue&type=script&setup=true&lang=js"

import "./ConfigurationModal.vue?vue&type=style&index=0&id=c3a6db10&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3a6db10"]])

export default __exports__